import {GameAvalancheRemoveWinsState} from 'src/avalanche/states/GameAvalancheRemoveWinsState';
import {GameRecodeLogic} from 'src/logic/recode/GameRecodeLogic';
import {GameAvalancheReelsView} from 'src/avalanche/GameAvalancheReelsView';

export class TopGameAvalancheRemoveWinsState extends GameAvalancheRemoveWinsState {

	protected startSymbolsRemoving(): void {
		const delay = GameAvalancheRemoveWinsState.BEFORE_REMOVE_TIMEOUT;

		this.module.timeUtils.createTimer(() => {
				const gameLogic: GameRecodeLogic = this.module.logic as GameRecodeLogic;

				(this.view as GameAvalancheReelsView).removeSymbolsOnAvalancheWithSound(
					gameLogic.getSpinResult().symbolsToRemove, gameLogic.getSpinWin(), gameLogic.getTotalBet());
			},
			delay,
		);
	}
}



// WEBPACK FOOTER //
// ./src/topreels/states/TopGameAvalancheRemoveWinsState.ts